import InternalServer from '../../app/features/InternalServerPage'
const InternalServerPage = () => {
    return (
        <>
            <InternalServer />
        </>
    )
}

export default InternalServerPage